import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Updated imports
import Home from './components/Home';
import Gallery from './components/Gallery';
import AboutPage from './components/AboutPage';
import OpPage from './components/OurProgramsPage';
import WhyUsPage from './components/WhyUs';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ContactUsPage from './components/ContactUsPage';
import ScrollToTopButton from './components/Stt';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800, // animation duration in ms
      once: true, // whether animation should happen only once
    });
  }, []);
  return (
    <Router>
      <div className="App">
        <Navbar />
        <div className="main-content">
          <Routes> 
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<OpPage />} />
            <Route path="/whyus" element={<WhyUsPage />} />
            <Route path="/contact" element={<ContactUsPage />} />
          </Routes> 
        </div>
        <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
